(() => {
  const selector = '.argewine-cart-goal';

  function bottleWord(count) {
    return count === 1 ? 'bottle' : 'bottles';
  }

  function updateGoal(goal, itemCount) {
    const minimum = Number(goal.dataset.minimumBottles || 4);
    const freeShipping = Number(goal.dataset.freeShippingBottles || 6);
    const count = Math.max(0, Number(itemCount) || 0);
    const message = goal.querySelector('.argewine-cart-goal__message');
    const countBadge = goal.querySelector('.argewine-cart-goal__count');
    const progress = goal.querySelector('.argewine-cart-goal__progress');

    goal.hidden = count === 0;
    goal.dataset.itemCount = String(count);
    goal.dataset.state = count < minimum ? 'minimum' : count < freeShipping ? 'shipping' : 'free';

    if (progress) {
      progress.style.width = `${Math.min((count / freeShipping) * 100, 100)}%`;
    }

    if (countBadge) {
      countBadge.textContent = `${Math.min(count, freeShipping)} / ${freeShipping} bottles`;
    }

    if (!message) return;

    if (count < minimum) {
      const remaining = minimum - count;
      message.textContent = `Add ${remaining} more ${bottleWord(remaining)} to complete the ${minimum}-bottle minimum.`;
    } else if (count < freeShipping) {
      const remaining = freeShipping - count;
      message.textContent = `Minimum reached — add ${remaining} more ${bottleWord(remaining)} for free priority shipping.`;
    } else {
      message.textContent = 'Free priority shipping unlocked.';
    }
  }

  function updateAll(itemCount) {
    document.querySelectorAll(selector).forEach((goal) => updateGoal(goal, itemCount));
  }

  function refreshFromCart() {
    fetch('/cart.js', { headers: { Accept: 'application/json' } })
      .then((response) => response.ok ? response.json() : Promise.reject(response))
      .then((cart) => updateAll(cart.item_count))
      .catch(() => {});
  }

  document.addEventListener('DOMContentLoaded', () => {
    document.querySelectorAll(selector).forEach((goal) => updateGoal(goal, goal.dataset.itemCount));
    refreshFromCart();
  });

  document.addEventListener('cart:updated', (event) => {
    const count = event.detail && event.detail.cart ? event.detail.cart.item_count : undefined;
    if (typeof count === 'number') {
      updateAll(count);
    } else {
      refreshFromCart();
    }
  });
})();